import "./AdvanceSetting.less"
import { CloseBtn } from "../CloseBtn/CloseBtn";
import Images from "../../utils/Images";
import { SliderWithInput } from "../SliderWithInput/SliderWithInput";
import { inject, observer } from "mobx-react";
import getStoreFromProps from "../../store/getStoreFromProps";
import { Select, InputNumber, Input, Switch } from "antd";
import { randomSeed } from "../../utils/misc";
import { useRef, useState } from "react";

type AdvanceSettingProps = {
    onClose: () => void;
};

export const MIXED_PRECISION_OPTIONS:any[] = [
    {label: "no", value: "no"},
    {label: "fp16", value: "fp16"},
    {label: "bf16", value: "bf16"}
];

export const SAMPLER_OPTIONS: any[] = [
    {label: "Euler", value: "EULER"},
    {label: "DDIM", value: "DDIM"},
    {label: "Euler a", value: "EULER_A"},
    {label: "DPMPP", value: "DPMPP"},
    {label: "DPMPP_SDE", value: "DPMPP_SDE"},
    {label: "UNIPC", value: "UNIPC"},
    {label: "EULER_KARRAS", value: "EULER_KARRAS"},
    {label: "DPMPP_KARRAS", value: "DPMPP_KARRAS"},
    {label: "DPM_SDE_KARRAS", value: "DPM_SDE_KARRAS"},
    {label: "UNIPC_KARRAS", value: "UNIPC_KARRAS"}
];

export const SAVE_PRECISION_OPTIONS: any[] = [
    // {label: "none", value: "NONE"},
    // {label: "float_8", value: "FLOAT_8"},
    // {label: "float_16", value: "FLOAT_16"},
    // {label: "float_32", value: "FLOAT_32"},
    {label: "bfloat_16", value: "BFLOAT_16"},
    // {label: "tfloat_32", value: "TFLOAT_32"},
    // {label: "int_8", value: "INT_8"},
    // {label: "nfloat_4", value: "NFLOAT_4"}
];

export const LEARNING_RATE_OPTIONS: any[] = [
    {label: "1e-6", value: "1e-6"},
    {label: "1e-5", value: "1e-5"},
    {label: "5e-5", value: "5e-5"},
    {label: "1e-4", value: "1e-4"},
    {label: "2e-4", value: "2e-4"},
];

export const LEARNING_RATE_OPTIONS_1: any[] = [
    {label: "1.0(建议仅使用Prodigy优化器时使用)", value: "1.0"},
    {label: "1.2", value: "1.2"},
    {label: "0.5", value: "0.5"}
];

export const LR_SCHEDULER_OPTIONS: any[] = [
    {label: "linear", value: "LINEAR"},
    {label: "cosine", value: "COSINE"},
    {label: "cosine_with_restarts", value: "COSINE_WITH_RESTARTS"},
    {label: "constant", value: "CONSTANT"},
    {label: "cosine_with_hard_restarts", value: "COSINE_WITH_HARD_RESTARTS"},
    {label: "rex", value: "REX"},
    {label: "Adafactor", value: "ADAFACTOR"},
    {label: "custom", value: "CUSTOM"}
];

export const OPTIMIZER_OPTIONS: any[] = [
    // {label: "ADAGRAD", value: "ADAGRAD"},
    // {label: "ADAGRAD_8BIT", value: "ADAGRAD_8BIT"},
    // {label: "Adam", value: "ADAM"},
    {label: "Adam_8Bit", value: "ADAM_8BIT"},
    // {label: "AdamW", value: "AdamW"},
    // {label: "AdamW8bit", value: "ADAMW_8BIT"},
    // {label: "AdEMAMix", value: "AdEMAMix"},
    // {label: "AdEMAMix_8Bit", value: "AdEMAMix_8BIT"},
    // {label: "SCHEDULE_FREE_ADAMW", value: "SCHEDULE_FREE_ADAMW"},
    // {label: "SCHEDULE_FREE_SGD", value: "SCHEDULE_FREE_SGD"},
    // {label: "DADAPT_ADA_GRAD", value: "DADAPT_ADA_GRAD"},
    // {label: "DADAPT_ADAM", value: "DADAPT_ADAM"},
    // {label: "DADAPT_ADAN", value: "DADAPT_ADAN"},
    // {label: "DADAPT_LION", value: "DADAPT_LION"},
    // {label: "DADAPT_SGD", value: "DADAPT_SGD"},
    // {label: "Lion", value: "LION"},
    // {label: "ADAFACTOR", value: "ADAFACTOR"},
    // {label: "CAME", value: "CAME"},
    // {label: "ADABELIEF", value: "ADABELIEF"},
    // {label: "TIGER", value: "TIGER"},
    // {label: "AIDA", value: "AIDA"},
    // {label: "Prodigy(仅支持设置总学习率，建议1.0)", value: "Prodigy"},
];

export const MAX_TOKEN_LENGTH_OPTIONS: any[] = [
    {label: "75", value: "75"},
    {label: "150", value: "150"},
    {label: "225", value: "225"},
];

const inputNumberWithTitle = (title: string, a: number, onChange: (a: number) => void): React.ReactElement => {
    return <div className="advance-setting-input-number-with-title">
        <InputNumber type="number" controls={false} variant="borderless" className="advance-setting-input" value={a} onChange={a => onChange(a as number)} min={512} max={1024}></InputNumber>
        <span>{title}</span>
    </div>;
};

const seedInput = (a: number, onChange: (a: number) => void): React.ReactElement => {
    return <div className="advance-setting-seed-input">
        <InputNumber type="number" controls={false} variant="borderless" className="advance-setting-input" value={a} onChange={a => onChange(a as number)} min={-1} precision={0}></InputNumber>
        <img src={Images.random} onClick={() => onChange(randomSeed(1, Math.pow(2, 32)))}></img>
    </div>;
};

const label = (english: string, chinese: string, content: string = ""): React.ReactElement => {
    return <div className="advance-setting-content-label">
        <span>{english}</span>
        <span>{chinese}</span>
        {content.length > 0 && <span>{content}</span>}
    </div>;
};

const suffix = <img src={Images.expand} style={{height: "0.1rem"}}></img>;

export const AdvanceSetting = inject("advanceSetting")(observer((props: AdvanceSettingProps): React.ReactElement => {
    const advanceSettingStore = getStoreFromProps(props, "advanceSetting");
    const trainParamRef = useRef<HTMLDivElement>(null);
    const sampleConfigRef = useRef<HTMLDivElement>(null);
    const saveSettingRef = useRef<HTMLDivElement>(null);
    const studyRef = useRef<HTMLDivElement>(null);
    const networkRef = useRef<HTMLDivElement>(null);
    const promptConfigRef = useRef<HTMLDivElement>(null);
    const noiseConfigRef = useRef<HTMLDivElement>(null);
    const advanceSettingRef = useRef<HTMLDivElement>(null);
    const [sideBtnIndex, setSideBtnIndex] = useState(0);

    const sideBtnsInfo: any[][] = [
        ["训练参数", trainParamRef],
        ["样图设置", sampleConfigRef],
        ["保存设置", saveSettingRef],
        ["学习率&优化器", studyRef],
        ["网络", networkRef],
        ["打标设置", promptConfigRef],
        ["噪声设置", noiseConfigRef],
        ["高级设置", advanceSettingRef]
    ];

    const onResolutionWidthChange = (a: number): void => {
        const resolution = advanceSettingStore.resolution;
        advanceSettingStore.resolution = [a, resolution[1]];
    };

    const onResolutionHeightChange = (a: number): void => {
        const resolution = advanceSettingStore.resolution;
        advanceSettingStore.resolution = [resolution[0],a];
    };

    const container = (a: HTMLElement): HTMLElement => {
        return a;
    };

    const trainParam = (): React.ReactElement => {
        return <div className="advance-setting-content-segment" ref={trainParamRef}>
            <div className="advance-setting-content-segment-title">训练参数</div>
            <div className="advance-setting-content-segment-row">
                {label("Repeat", "单张训练次数")}
                <SliderWithInput value={advanceSettingStore.repeat} onChange={a => advanceSettingStore.repeat = a} min={1} max={50}></SliderWithInput>
            </div>
            <div className="advance-setting-content-segment-row">
                {label("Epoch", "训练轮数")}
                <SliderWithInput value={advanceSettingStore.epoch} onChange={(a => advanceSettingStore.epoch = a)} min={1} max={20}></SliderWithInput>
            </div>
            <div className="advance-setting-content-segment-row">
                {label("Batch Size", "批量大小")}
                <SliderWithInput value={advanceSettingStore.batchSize} onChange={(a => advanceSettingStore.batchSize = a)} min={1} max={2}></SliderWithInput>
            </div>
            {/* <div className="advance-setting-content-segment-row">
                {label("Mixed precision", "训练混合精度")}
                <Select getPopupContainer={container} suffixIcon={suffix} value={advanceSettingStore.mixedPrecision} options={MIXED_PRECISION_OPTIONS} onChange={a => advanceSettingStore.mixedPrecision = a}></Select>
            </div> */}
        </div>;
    };

    const sampleConfig = (): React.ReactElement => {
        return <div className="advance-setting-content-segment" ref={sampleConfigRef}>
            <div className="advance-setting-content-segment-title">样图设置</div>
            <div className="advance-setting-content-segment-row">
                {label("Resolution", "样图分辨率")}
                {inputNumberWithTitle("width", advanceSettingStore.resolution[0], onResolutionWidthChange)}
                <span className="advance-setting-sampler-reso-mul">*</span>
                {inputNumberWithTitle("height", advanceSettingStore.resolution[1], onResolutionHeightChange)}
            </div>
            <div className="advance-setting-content-segment-row">
                {label("Seed", "随机种子数")}
                {seedInput(advanceSettingStore.seed, a => advanceSettingStore.seed = a)}
            </div>
            <div className="advance-setting-content-segment-row">
                {label("Sampler", "采样方式")}
                <Select getPopupContainer={container} suffixIcon={suffix} value={advanceSettingStore.sampler} options={SAMPLER_OPTIONS} onChange={a => advanceSettingStore.sampler = a}></Select>
            </div>
            <div className="advance-setting-content-segment-row">
                {label("Prompts", "提示词")}
                <div className="advance-setting-prompt-input-frame">
                    <Input.TextArea variant="borderless" style={{resize: "none"}} className="advance-setting-input" value={advanceSettingStore.prompt} onChange={e => advanceSettingStore.prompt = e.target.value}></Input.TextArea>
                </div>
            </div>
        </div>;
    };

    const saveSetting = (): React.ReactElement => {
        return <div className="advance-setting-content-segment" ref={saveSettingRef}>
            <div className="advance-setting-content-segment-title">保存设置</div>
            <div className="advance-setting-content-segment-row">
                {label("Save every N epochs", "每N轮保存一个LoRA")}
                <SliderWithInput value={advanceSettingStore.saveEveryNEpochs} onChange={a => advanceSettingStore.saveEveryNEpochs = a} min={1} max={10}></SliderWithInput>
            </div>
            <div className="advance-setting-content-segment-row">
                {label("Save precision", "LoRA保存精度")}
                <Select getPopupContainer={container} suffixIcon={suffix} value={advanceSettingStore.savePrecision} options={SAVE_PRECISION_OPTIONS} onChange={a => advanceSettingStore.savePrecision = a}></Select>
            </div>
        </div>;
    };

    const study = (): React.ReactElement => {
        return <div className="advance-setting-content-segment" ref={studyRef}>
            <div className="advance-setting-content-segment-title">学习率&优化器</div>
            <div className="advance-setting-content-segment-row">
                {label("Learning Rate", "总学习率", "分开设置 unet 和 text encoder学习率后这个值失效")}
                <Select getPopupContainer={container} suffixIcon={suffix} value={advanceSettingStore.learningRate} options={LEARNING_RATE_OPTIONS}
                    onChange={(a => advanceSettingStore.learningRate = a)}></Select>
            </div>
            <div className="advance-setting-content-segment-row">
                {label("Unet lr", "Unet学习率")}
                <InputNumber controls={false} variant="borderless" value={advanceSettingStore.unetlr} onChange={a => advanceSettingStore.unetlr = a as number} min={0.0001} max={1}></InputNumber>
            </div>
            <div className="advance-setting-content-segment-row">
                {label("Text encoder lr", "文本编码器学习率")}
                <InputNumber controls={false} variant="borderless" value={advanceSettingStore.textEncoderLr} onChange={a => advanceSettingStore.textEncoderLr = a as number} min={0.00001} max={1}></InputNumber>
            </div>
            <div className="advance-setting-content-segment-row">
                {label("Lr warm up", "学习率预热（%）")}
                <SliderWithInput value={advanceSettingStore.lrWarmUp} onChange={a => advanceSettingStore.lrWarmUp = a} min={0} max={100}></SliderWithInput>
            </div>
            <div className="advance-setting-content-segment-row">
                {label("Lr scheduler", "学习率调度器")}
                <Select getPopupContainer={container} suffixIcon={suffix} value={advanceSettingStore.lrScheduler} options={LR_SCHEDULER_OPTIONS} onChange={a => advanceSettingStore.lrScheduler = a}></Select>
            </div>
            <div className="advance-setting-content-segment-row">
                {label("Optimizer", "优化器")}
                <Select getPopupContainer={container} suffixIcon={suffix} value={advanceSettingStore.optimizer} options={OPTIMIZER_OPTIONS} onChange={a => advanceSettingStore.optimizer = a}></Select>
            </div>
            <div className="advance-setting-content-segment-row">
                {label("Lr scheduler num cycles", "重启次数")}
                <SliderWithInput value={advanceSettingStore.lrSchedulerNumCycles} onChange={a => advanceSettingStore.lrSchedulerNumCycles = a} min={1} max={5}></SliderWithInput>
            </div>
            <div className="advance-setting-content-segment-row">
                {label("Train unet only", "仅训练Unet")}
                <Switch value={advanceSettingStore.trainUnetOnly} onChange={e => advanceSettingStore.trainUnetOnly = e.valueOf()}></Switch>
            </div>
            <div className="advance-setting-content-segment-row">
                {label("Train text encoder only", "仅训练文本编码器")}
                <Switch value={advanceSettingStore.trainTextEncoderOnly} onChange={e => advanceSettingStore.trainTextEncoderOnly = e.valueOf()}></Switch>
            </div>
            <div className="advance-setting-content-segment-row">
                {label("Min snr gamma", "最小信噪比伽马值")}
                <SliderWithInput value={advanceSettingStore.minSnrGamma} onChange={a => advanceSettingStore.minSnrGamma = a} min={0} max={20}></SliderWithInput>
            </div>
        </div>;
    };

    const network = (): React.ReactElement => {
        return <div className="advance-setting-content-segment" ref={networkRef}>
            <div className="advance-setting-content-segment-title">网络</div>
            <div className="advance-setting-content-segment-row">
                {label("Network Rank Dim", "网络大小", "常用4~128")}
                <SliderWithInput value={advanceSettingStore.networkRankDim} onChange={a => advanceSettingStore.networkRankDim = a} min={1} max={64}></SliderWithInput>
            </div>
            <div className="advance-setting-content-segment-row">
                {label("Network Alpha", "网络Alpha", "常用dim相同的值or更小")}
                <SliderWithInput value={advanceSettingStore.networkAlpha} onChange={a => advanceSettingStore.networkAlpha = a} min={1} max={64}></SliderWithInput>
            </div>
        </div>;
    };

    const promptConfig = (): React.ReactElement => {
        return <div className="advance-setting-content-segment" ref={promptConfigRef}>
            <div className="advance-setting-content-segment-title">打标设置</div>
            <div className="advance-setting-content-segment-row">
                {label("keep n tokens", "保持n个token")}
                <SliderWithInput value={advanceSettingStore.keepNTokens} onChange={a => advanceSettingStore.keepNTokens = a} min={1} max={225}></SliderWithInput>
            </div>
            <div className="advance-setting-content-segment-row">
                {label("Max token length", "最大token长度")}
                <Select getPopupContainer={container} suffixIcon={suffix} value={advanceSettingStore.maxTokenLength} options={MAX_TOKEN_LENGTH_OPTIONS} onChange={a => advanceSettingStore.maxTokenLength = a}></Select>
            </div>
        </div>;
    };

    const noiseConfig = (): React.ReactElement => {
        return <div className="advance-setting-content-segment" ref={noiseConfigRef}>
            <div className="advance-setting-content-segment-title">噪声设置</div>
            <div className="advance-setting-content-segment-row">
                {label("Noise offset（0~1）", "噪声偏移", "设置金字塔噪声后这个值失效")}
                <SliderWithInput value={advanceSettingStore.noiseOffset} onChange={a => advanceSettingStore.noiseOffset = a} min={0} max={1} step={0.0001} prcision={2}></SliderWithInput>
            </div>
            <div className="advance-setting-content-segment-row">
                {label("Multires noise iterations", "多分辨率（金字塔）噪声扩散次数")}
                <SliderWithInput value={advanceSettingStore.multiresNoiseIterations} onChange={a => advanceSettingStore.multiresNoiseIterations = a} min={0} max={64}></SliderWithInput>
            </div>
            <div className="advance-setting-content-segment-row">
                {label("Multires noise discount", "多分辨率（金字塔）衰减率")}
                <SliderWithInput value={advanceSettingStore.multiresNoiseDiscount} onChange={a => advanceSettingStore.multiresNoiseDiscount = a} min={0} max={1}></SliderWithInput>
            </div>
        </div>;
    };

    const advanceSetting = (): React.ReactElement => {
        return <div className="advance-setting-content-segment" ref={advanceSettingRef}>
            <div className="advance-setting-content-segment-title">高级设置</div>
            <div className="advance-setting-content-segment-row">
                {label("Seed", "随机种子数")}
                {seedInput(advanceSettingStore.advanceSeed, a => advanceSettingStore.advanceSeed = a)}
            </div>
            <div className="advance-setting-content-segment-row">
                {label("clip skip", "clip跳过")}
                <SliderWithInput value={advanceSettingStore.clipSkip} onChange={a => advanceSettingStore.clipSkip = a} min={1} max={2}></SliderWithInput>
            </div>
        </div>;
    };

    const onSideBtnClick = (index: number): void => {
        setSideBtnIndex(index);
        sideBtnsInfo[index][1].current.scrollIntoView({behavior: "smooth"})
    };

    return <div className="fullscreen-mask fullscreen-dialog-bg-color">
        <div className="advance-setting">
            <CloseBtn onClick={props.onClose}></CloseBtn>
            <div className="advance-setting-title-wrap">
                <img src={Images.gear}></img>
                <span>专业参数</span>
            </div>
            <div className="advance-setting-content">
                <div className="advance-setting-content-left-btns-wrap">
                    {sideBtnsInfo.map((item, i) =>
                        <div key={i} data-select={sideBtnIndex === i} className="advance-setting-content-left-btn" onClick={() => onSideBtnClick(i)}>{item[0]}</div>)}
                </div>
                <div className="advance-setting-content-segments-wrap no-scrollbar">
                    {trainParam()}
                    {sampleConfig()}
                    {saveSetting()}
                    {study()}
                    {network()}
                    {promptConfig()}
                    {noiseConfig()}
                    {advanceSetting()}
                </div>
            </div>
        </div>
    </div>;
}));